import { render, staticRenderFns } from "./Scrumbs.vue?vue&type=template&id=f7c30cc6&"
import script from "./Scrumbs.vue?vue&type=script&lang=ts&"
export * from "./Scrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports